import type { TranslationKey } from '@/i18n/types'

export type VideoInfo = {
  id: string
  titleKey: TranslationKey
  youtubeId: string
}

export const INTRO_VIDEO: VideoInfo = {
  id: 'kom-igang',
  titleKey: 'videos.introTitle',
  youtubeId: 'aUhSn2FZu_U',
}

export const UPLOAD_DOCUMENTS_VIDEO: VideoInfo = {
  id: 'ladda-upp-dokument',
  titleKey: 'videos.uploadDocumentsTitle',
  youtubeId: '8Zq09R7zRJk',
}

export const FIND_SUPPORT_VIDEO: VideoInfo = {
  id: 'hitta-stod',
  titleKey: 'videos.findSupportTitle',
  youtubeId: 'HEOb2RcUReQ',
}

export const ERRANDS_VIDEO: VideoInfo = {
  id: 'arenden-och-ansokan',
  titleKey: 'videos.errandsTitle',
  youtubeId: '3FwtCp_UbeQ',
}

export const CONVERSATIONS_VIDEO: VideoInfo = {
  id: 'konversationer',
  titleKey: 'videos.conversationsTitle',
  youtubeId: 'lJdmCnEZFQg',
}

export const TIMELINE_VIDEO: VideoInfo = {
  id: 'tidslinjen',
  titleKey: 'videos.timelineTitle',
  youtubeId: 'uEi_r4Da-_c',
}

export const INVITE_VIDEO: VideoInfo = {
  id: 'bjud-in',
  titleKey: 'videos.inviteTitle',
  youtubeId: 'ZBOKFs5NJhY',
}

export const ALL_VIDEOS: VideoInfo[] = [
  INTRO_VIDEO,
  UPLOAD_DOCUMENTS_VIDEO,
  FIND_SUPPORT_VIDEO,
  ERRANDS_VIDEO,
  CONVERSATIONS_VIDEO,
  TIMELINE_VIDEO,
  INVITE_VIDEO,
]
